import React, { useState, useRef, useEffect } from "react";
import {
  EntryBase,
  Arrow,
  HeaderBase,
  HeaderText,
  Content,
  HelpCenterContentWrapper,
  HelpCenterURL,
  HelpCenterText,
  HelpCenterButton,
} from "./nested-content-entry.styled";
import { PrismicRichTextField, Scalars } from "../../types/graphql";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { PrismicRichText } from "@prismicio/react";
import { trackSearchResultClicked } from "../../utils/analytics";
import { helpCenterAlgoliaIndexName } from "../../utils/constants";
import { SiteSearchResults } from "../search/config";
import { HelpCenterHitType } from "../search/search-content/help-center-hits/help-center-hits";
import { Hit } from "react-instantsearch-core";
import * as FA from "../../styles/fontawesome";

interface IEntryProps {
  header: string;
  prismicContent?: Pick<PrismicRichTextField, "richText">;
  helpCenterContent?: {
    entryText: string;
    entryURL: string;
    hit: Hit<HelpCenterHitType>;
    hitIndex: number;
    searchData: SiteSearchResults;
  };
  contentLayout?: string;
  expanded: boolean;
}

const Entry = (props: IEntryProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef: any = useRef(null);

  useEffect(() => {
    setContentHeight(contentRef?.current?.clientHeight);
  });

  useEffect(() => {
    setIsOpen(props.expanded);
  }, [props.expanded]);

  const trackHelpCenterResultClicked = () => {
    if (props.helpCenterContent) {
      const { title } = props.helpCenterContent.hit;
      const { query, queryID, page } = props.helpCenterContent.searchData;
      const resultType = query ? "page" : "noSearch";
      trackSearchResultClicked(
        title,
        helpCenterAlgoliaIndexName,
        query,
        props.helpCenterContent.hit,
        queryID,
        page,
        resultType,
        props.helpCenterContent.hitIndex
      );
    }
  };

  return (
    <EntryBase>
      <HeaderBase isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        {props.header && <HeaderText>{props.header}</HeaderText>}
        <Arrow isOpen={isOpen} css={FA.AngleDownSolid} />
      </HeaderBase>
      {(props.prismicContent && (
        <Content isOpen={isOpen} contentHeight={contentHeight}>
          <div className={props.contentLayout} ref={contentRef}>
            <PrismicRichText
              field={props.prismicContent.richText}
              components={htmlSerializer}
            />
          </div>
        </Content>
      )) ||
        (props.helpCenterContent && (
          <Content isOpen={isOpen} contentHeight={contentHeight}>
            <HelpCenterContentWrapper ref={contentRef}>
              <HelpCenterText>
                <HelpCenterURL
                  href={props.helpCenterContent.entryURL}
                  target="_blank"
                  onClick={() => {
                    trackHelpCenterResultClicked();
                  }}
                >
                  <i css={FA.ArrowUpRightFromSquareRegular} />{" "}
                  {props.helpCenterContent?.entryURL}
                </HelpCenterURL>
                {/* Display first 50 words */}
                <div>
                  {props.helpCenterContent.entryText
                    .split(" ")
                    .slice(0, 50)
                    .join(" ")
                    .trim()}
                  ...
                </div>
              </HelpCenterText>
              <HelpCenterButton
                kind="outline-blue"
                scale="large"
                onClick={() => {
                  trackHelpCenterResultClicked();
                  window.open(props.helpCenterContent?.entryURL, "_blank");
                }}
              >
                View Article
              </HelpCenterButton>
            </HelpCenterContentWrapper>
          </Content>
        ))}
    </EntryBase>
  );
};

export default Entry;
